export default [
    {
        path: '/staff',
        component: () => import('@/views/staff'),
        meta: {
			menuActive: '/staff',
		},
    },
    {
        path: '/staff/add',
        component: () => import('@/views/staff/add'),
        meta: {
			menuActive: '/staff',
		},
    },
    {
        path: '/staff/:id/edit',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/staff/edit'),
        meta: {
			menuActive: '/staff',
		},
    },
]